import { AnfrageListDisplayModel } from '@/api/model-index';
import { ConfirmationDialogAction, ConfirmationDialogComponent, ConfirmationDialogResult } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { IdToken } from '@/core/models/id-token.model';
import { AnfrageLiveSharingService } from '@/core/services/anfrage-live-sharing.service';
import { I18nService } from '@/core/services/i18nService';
import { PortalContextService } from '@/core/services/portal-context.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { DialogService } from '@progress/kendo-angular-dialog';
import { Constants } from '@/constants';

@Component({
  selector: 'anfrage-live-sharing',
  templateUrl: './anfrage-live-sharing.component.html',
  styleUrls: ['./anfrage-live-sharing.component.scss']
})
export class AnfrageLiveSharingComponent implements OnInit, OnDestroy {

  protected isAlreadyInformed = false;

  public get anfrage(): AnfrageListDisplayModel {
    return this.portalContextService.CurrentAnfrage
  }

  constructor(protected portalContextService: PortalContextService, public dialogService: DialogService, protected anfrageLiveSharingService: AnfrageLiveSharingService, protected translateService: I18nService) {
  }
  
  ngOnDestroy(): void {
    this.anfrageLiveSharingService.livePortalzugriffe = [];
  }

  userToken() {
    return localStorage.getItem(IdToken.name);
  }

  ngOnInit(): void {
    let windowAny: any = window;
    windowAny.interopFunctions = {
      anfragesharingcurrent: (e: string[]) => {
        this.anfrageLiveSharingService.livePortalzugriffe = e;
        this.anfrageLiveSharingService.livePortalzugriffeBehavior.next(e);
        this.anfrageSharingCurrentUpdate();
      }
    }
  }

  anfrageSharingCurrentUpdate() {
    if (!this.isAlreadyInformed && this.anfrageLiveSharingService.livePortalzugriffe.length >= 2) {
      let otherUsersDialog = this.dialogService.open({
        content: ConfirmationDialogComponent,
        maxWidth: Constants.DIALOG.MAX_WIDTH,
        maxHeight: Constants.DIALOG.MAX_HEIGHT,
        title: this.translateService.instant("livesharingdialog.title")
      });
  
      let dialogComponent: ConfirmationDialogComponent = otherUsersDialog.content.instance;

      dialogComponent.content = this.translateService.instant("livesharingdialog.content");
  
      otherUsersDialog.result.subscribe(result => this.onAlreadyInformedDialogClose(<ConfirmationDialogResult>result));

      this.isAlreadyInformed = true;

      //Bugfix: Kendo Dialog öffnet sich erst nach einem click
      (document.getElementById("blazor-anfrage-sharing") as HTMLElement).click();
    }
  }

  onAlreadyInformedDialogClose(result: ConfirmationDialogResult) {
    if (result.action == ConfirmationDialogAction.Confirm) {
      this.anfrageLiveSharingService.openFreigebenDialog(this.portalContextService.CurrentAnfrage.id, this.portalContextService.CurrentAnfrage.objektTyp!, null, true);
    }
  }
}
